import React, { Component} from 'react';
import { 
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogTitle,
    CircularProgress
} from '@material-ui/core';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { 
    firestoreDeleteContact
} from  '../../../store/actions/firebase.action';

class ContactDialogDelete extends Component {

  // ====================== Inits ====================== //
    
    constructor() {
        super();
        // state
        this.state = {
            error: '',
            loading: false,
        };
    }

    // ====================== Functions ====================== //

    // ====================== Firebase Functions ====================== //

    handleDeleteContact = () => {
        const { contact, contacts } = this.props;
        this.setState({
            loading: true,
        }, () => {
            this.props.firestoreDeleteContact({ contact, contacts }, () => {
                this.setState({
                    loading: false,
                }, () => {
                    this.props.handleSuccess();
                })
            });
        })
    }

    // ====================== Render Component ====================== //


    renderDeleteButton = () =>{
        const { loading } = this.state;
        if (loading) {
          return (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className='add-btn'
              disabled
              startIcon={<CircularProgress size={15}/>}
            >
              Delete
            </Button>
          );
        }
        return (
          <Button 
            onClick={() => this.handleDeleteContact()} 
            type="submit"
            variant="contained"
            className='add-btn'
            style={{ backgroundColor: 'red', color: '#fff' }}
          >
            Delete
          </Button>
        );
    }

    
    // ====================== Render Main ====================== //

    render() {
        const { error, loading } = this.state;
        const { dialogOpen, handleClose, contact } = this.props;
        const contactName = contact && contact.contactName;
        return (
            <Dialog
                open={dialogOpen}
                onClose={handleClose}
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                maxWidth='sm'
                fullWidth
            >
            <DialogTitle id="scroll-dialog-title">Remove Contact {contactName}</DialogTitle>
            <DialogContent dividers >
              <p>Are you sure to delete "{contactName}". This action can't be undone.</p>
              <div className="red-text center">
                  { error ? <p>{error}</p> : null }
              </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                {this.renderDeleteButton()}
            </DialogActions>
        </Dialog>
    );
  }
}

const mapStateToProps = (state) => ({
    contacts: state.firebaseWeb.contacts,
});
    

const mapDispatchToProps = {
    firestoreDeleteContact
}
  
export default compose(connect(mapStateToProps,mapDispatchToProps))(ContactDialogDelete)